import axios from '../../_utils/axios';

// ----------------------------------------------------------------------

const deleteSoilSensors = async (sensorId) => {
  return await axios.delete(`soil-sensors/${sensorId}`)
    .catch((error) => {
      return Promise.reject(error);
    });
};

export default deleteSoilSensors;